/**
 * Размер файла человеку: «1,4 МБ», «320 КБ».
 *
 * Одна функция на вложения переписки — чат, обращение, композер: один и тот же
 * файл в ленте и в форме должен называться одинаково.
 *
 * Байты не показываем вовсе: файл меньше килобайта — это пустышка или промах
 * выбора, а «0 КБ» выглядит как поломка.
 */
export function formatFileSize(bytes: number): string {
	if (bytes >= 1024 * 1024) {
		return `${(bytes / 1024 / 1024).toFixed(1)} МБ`;
	}

	return `${Math.max(1, Math.round(bytes / 1024))} КБ`;
}
